module.exports = __webpack_public_path__ + "img/V7.c9328b07.png";